import { createFileRoute } from "@tanstack/react-router";

import { RolesPermissionsPage } from "@/pages/Admin";

export const Route = createFileRoute("/app/admin/roles")({
  component: RolesPermissionsPage,
});
